
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 548.797 548.797"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M476.249 20.818C462.394-.412 433.966-6.385 412.724 7.464L107.82 206.474c-27.185 16.01-42.742 40.692-42.742 67.92s15.557 51.903 42.742 67.926l304.904 199.004c7.748 5.056 16.445 7.473 25.049 7.473 14.982 0 29.682-7.332 38.477-20.814 13.861-21.229 7.883-49.67-13.348-63.525L171.705 274.395l291.196-190.05c21.23-13.857 27.203-42.296 13.348-63.527z"}})])
          )
        }
      }
    